var map = {
	"./Brazil.png": 99087,
	"./CAMBODIA.png": 97273,
	"./India.png": 1542,
	"./Mexico.png": 72303,
	"./THAILAND.png": 79100,
	"./US.png": 19473,
	"./VIETNAM.png": 63989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24776;